import React from 'react'

export default function Bnbs() {
  return (
    <div>Bnbs</div>
  )
}
